module.exports = __webpack_public_path__ + "img/pos_s1_icon2.312e27f3.png";